import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';

import DateFormat from '@/core/date/date-format';
import { useTimer } from '@/shared/hooks/export';

export default function Clock() {
  const [date, setDate] = useState<Dayjs>(dayjs());

  useTimer(
    100,
    () => {
      const now = dayjs();
      setDate(prev => (prev.unix() === now.unix() ? prev : now));
    },
    true,
  );

  return (
    <>
      {' '}
      <DateFormat format={'h:mm:ss a'} date={date} />
    </>
  );
}
